export enum processType {
    WAITING = 'waiting',
    PROCESSING = 'processing',
    FACE_NET_PROCESSING = 'faceNetProcessing',
    UPLOADING = 'uploading',
    DETECTED_CAMERA = 'detectedCamera',
}
